import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'WebApplicability' })({
    container: {
        display: 'inline-flex',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        fontSize: 10,
        fontWeight: 600,
        lineHeight: '16px',
        letterSpacing: '0.1em',
        textTransform: 'uppercase',
        color: '#8E8E8E',
        cursor: 'pointer'
    },
    content: {
        fontWeight: 500,
        fontSize: 14,
        lineHeight: '21px',
        color: '#2D2D2D'
    },
    tooltip: {
        background: '#FFFFFF',
        filter: 'drop-shadow(0px 0px 10px rgba(141, 141, 141, 0.1)) drop-shadow(0px 20px 40px rgba(141, 141, 141, 0.1))',
        borderRadius: 16,
        padding: 16,
        gap: 16,
        color: 'inherit',
        display: 'flex',
        flexDirection: 'column'
    }
});
